import { articles } from '@/mocks/articles';
import { SITE_URL, SITE_NAME, FAVICON_URL, resolveSeo, normalizePath } from './seoData';

/**
 * Build the Schema.org JSON-LD objects for a given route.
 * Returns an array of objects that will be injected as a single script tag.
 */
export function buildJsonLd(pathname: string): Record<string, unknown>[] {
  const seo = resolveSeo(pathname);
  const p = normalizePath(pathname);
  const url = SITE_URL + seo.path;
  const result: Record<string, unknown>[] = [];

  if (p === '/') {
    result.push({
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: SITE_NAME,
      url: SITE_URL + '/',
      description: seo.description,
      inLanguage: ['pt-BR', 'de-DE', 'en-US'],
    });
    result.push({
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL + '/',
      logo: FAVICON_URL,
    });
    return result;
  }

  if (seo.type === 'article') {
    result.push({
      '@context': 'https://schema.org',
      '@type': 'BlogPosting',
      headline: seo.title,
      description: seo.description,
      url,
      mainEntityOfPage: { '@type': 'WebPage', '@id': url },
      author: { '@type': 'Organization', name: 'CSSBuyBR Team' },
      publisher: {
        '@type': 'Organization',
        name: SITE_NAME,
        logo: { '@type': 'ImageObject', url: FAVICON_URL },
      },
      datePublished: '2026-08-15',
      dateModified: '2026-08-30',
      inLanguage: 'pt-BR',
    });
  } else {
    const type = p === '/about' ? 'AboutPage' : 'WebPage';
    result.push({
      '@context': 'https://schema.org',
      '@type': type,
      name: seo.title,
      description: seo.description,
      url,
    });
  }

  const articleMatch = p.match(/^\/article\/([^/]+)$/);
  if (articleMatch) {
    const article = articles.find((a) => a.slug === articleMatch[1]);
    if (article && article.faq.length > 0) {
      result.push({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: article.faq.map((f) => ({
          '@type': 'Question',
          name: f.q,
          acceptedAnswer: { '@type': 'Answer', text: f.a },
        })),
      });
    }
  }

  return result;
}